import { useEffect, useRef } from 'react';
export function useThrottleEffect(effect, deps, limit) {
    if (limit === void 0) { limit = 200; }
    var lastTimeout = useRef(null);
    var cleanupRef = useRef(null);
    useEffect(function () {
        lastTimeout.current = setTimeout(function () {
            var cleanup = effect();
            if (typeof cleanup === 'function') {
                cleanupRef.current = cleanup;
            }
            lastTimeout.current = null;
        }, limit);
        return function () {
            if (lastTimeout.current) {
                clearTimeout(lastTimeout.current);
                lastTimeout.current = null;
            }
            // Run cleanup on unmount or dependency change
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
